import { CalendarPage } from "./CalendarPage";

export { CalendarAgenda } from "./CalendarAgenda";
export { CalendarForm } from "./CalendarForm";
export { CalendarList } from "./CalendarList";
export { CalendarPage } from "./CalendarPage";

export default {
  list: CalendarPage,
};
